import React, { useMemo } from "react"
import {
  setDate,
  getISODay,
  getDaysInMonth,
  endOfMonth,
  differenceInCalendarWeeks,
  isPast,
  isToday,
  format,
} from "date-fns"
import cx from "classnames"
import {
  CalendarViewMonthType,
  MonthType,
  CalendarViewDateType,
  DateType,
} from "./types"

type Props = MonthType

const CalendarViewMonth = ({
  monthName,
  monthStart,
  statusByDate = {},
  isSundayFirstDayOfWeek = false,
}: Props) => {
  const getMonthByWeek = (): CalendarViewMonthType => {
    const daysInMonth = getDaysInMonth(monthStart)
    const weeksInMonth =
      differenceInCalendarWeeks(endOfMonth(monthStart), monthStart, {
        weekStartsOn: isSundayFirstDayOfWeek ? 0 : 1,
      }) + 1
    const weekDay = isSundayFirstDayOfWeek
      ? (getISODay(monthStart) % 7) + 1
      : getISODay(monthStart)
    const month: CalendarViewDateType[][] = []
    let cursor = 0
    let date = 0

    for (let week = 0; week < weeksInMonth; week++) {
      month[week] = []
      for (let day = 0; day < 7; day++) {
        month[week][day] = { date: null }

        if (cursor >= weekDay - 1 && date < daysInMonth) {
          month[week][day].date = ++date as DateType

          const currentDate = setDate(monthStart, date)

          month[week][day].status =
            isPast(currentDate) && !isToday(currentDate)
              ? "past"
              : statusByDate[format(currentDate, "yyyy-MM-dd")]
        }
        cursor++
      }
    }
    return month
  }

  const monthByWeek = useMemo(() => getMonthByWeek(), [])

  return (
    <div className="cobalt-CalendarView__month">
      <div className="cobalt-CalendarView__monthName">{monthName}</div>
      <div className="c-flex c-flex-col c-gap-2xs">
        {monthByWeek.map((week, weekIndex) => (
          <div key={weekIndex} className="cobalt-CalendarView__week">
            {week.map((day, dayIndex) => (
              <div
                key={weekIndex + 1 * dayIndex + 1}
                className={cx("cobalt-CalendarView__day", {
                  [`cobalt-CalendarView__day--${day.status}`]: day.status,
                })}
              >
                {day.date}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

CalendarViewMonth.displayName = "CalendarViewMonth"

export default CalendarViewMonth
